import {createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../messages/routes.messages";

import {DiagramPage} from "./-page/diagram.page";

export const Route = createFileRoute("/_app/diagram/$diagramId/")({
  component: RouteComponent,
  staticData: {
    meta: {
      labelDescriptor: routeMessages.diagrams,
      nav: {visible: false},
    },
  },
});

function RouteComponent() {
  const {diagramId} = Route.useParams();

  return <DiagramPage diagramId={diagramId} />;
}
